module.exports = __webpack_public_path__ + "img/IB.3e46972c.png";